import { mapGetters } from "vuex";
import apiService from "../../../api/api.service";
import rules from "../../../utils/rules";
import countryPhoneCodes from "../../../utils/countryPhoneCodes.json";
import pageheader from "../../pageheader";
import utils from "../../../utils/util";
export default {
  name: "point-of-contacts",
  components: { pageheader },
  props: [],
  data() {
    return {
      editing: false,
      formType: "",
      countryPhoneCodes,
      isloading: false,
      loading: false,
      input: {},
      contact: {
        isValid: true,
      },
      valid: true,

      phoneCountryCode: "1",
      cellCountryCode: "1",
      phoneCountryName: "us",
      cellCountryName: "us",
      shiftSearchFilter: "",
      rules: rules,
    };
  },
  watch: {
    "$route.query.type": {
      handler: function (type) {
        this.formType = type;
      },
    },
  },

  created() {
    if ("id" in this.$route.params) {
      this.getContactsById();
      this.editing = true;
    } else {
      this.clearForm();
    }
  },
  computed: {
    ...mapGetters(["roles", "basicCustomers", "companyIdDropdown"]),
  },
  mounted() {
    this.input = utils.getInputContent("pointofcontacts", this.roles);

    if (this.formType == "") {
      this.clearForm();
    }
  },
  methods: {
    clearForm() {
      this.contact = {
        name: "",
        email: "",
        phone: "",
      };
    },
    async getContactsById() {
      try {
        this.isloading = true;
        let response = await apiService.getContactById(this.$route.params.id);
        if (response.data) {
          this.isloading = false;

          this.contact = response.data;
        }
      } catch (err) {
        this.loading = false;
        console.log("error", err);
      }
      this.formType = "edit";
    },
    onSelectOffice({ name, iso2, dialCode }) {
      this.cellCountryCode = dialCode;
      this.cellCountryName = iso2;
      console.log(name, iso2, dialCode);
    },
    reset() {
      this.$refs.form.reset();
      this.$router.push({
        path: "/point-of-contacts/list",
      });
    },
    async contactSave() {
      let userPhoneNumber = this.contact.phone.replace(/\D+/g, "");

      if (this.$refs.form.validate()) {
        this.loading = true;
        let payload = {
          name: this.contact.name,
          email: this.contact.email,
          phoneCountryCode: this.phoneCountryCode,
          phoneNumber: userPhoneNumber,
        };
        console.log(payload);

        try {
          var apiResponse;

          if (this.$route.query.type == "edit") {
            apiResponse = await apiService.updateContact(
              this.$route.params.id,
              payload
            );
          } else {
            // (payload.officePhone = this.user.officePhone),
            let payloaduser = {
              name: this.contact.name,
              email: this.contact.email,
              phone: userPhoneNumber,
            };
            console.log(payloaduser);
            apiResponse = await apiService.createContact(payloaduser);
          }

          if (apiResponse) {
            this.loading = false;
            this.$refs.form.reset();
            this.$toast.success(apiResponse.systemMessage);
            this.$router.push({
              path: "/point-of-contacts/list",
            });
          }
        } catch (err) {
          this.loading = false;
          this.$toast.error("Unable to create contact" + err);
        }
      }
    },
  },
};
